<!-- @format -->

<template>
  <div class="text-center">
    <audio ref="sound" src="../assets/notif.mp3" class="hidden"></audio>
    <v-menu
      min-width="300"
      content-class="shadow"
      :close-on-content-click="false"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <button
          v-on="on"
          v-bind="attrs"
          :class="countNotif !== 0 ? 'text-blue-500' : 'text-stone-700'"
          class="w-11 h-11 relative rounded-full bg-white flex items-center justify-center shadow"
        >
          <span
            v-if="countNotif"
            class="w-5 h-5 rounded-full flex items-center justify-center text-xs bg-blue-500 text-white absolute -top-1 -right-1"
            >{{ countNotif }}</span
          >
          <v-icon v-if="countNotif !== 0" style="color: inherit"
            >mdi-bell-ring</v-icon
          >
          <v-icon v-else style="color: inherit">mdi-bell</v-icon>
        </button>
      </template>
      <div class="bg-white rounded-lg">
        <div class="title flex items-center justify-between p-5 border-b">
          <span class="text-lg font-bold text-blue-800">اعلان ها</span>
          <button
            @click="clearNotifList"
            class="bg-red-50 text-red-700 rounded-lg hover:bg-red-100 duration-200"
          >
            <span class="text-xs px-3 py-2 block">پاک کردن</span>
          </button>
        </div>

        <div v-if="notifList && notifList?.length !== 0" class="p-3 space-y-2">
          <router-link
            v-for="(notif, index) in notifList"
            :key="index"
            :to="notif.route"
          >
            <div
              @click="changeStatus(index)"
              :class="[notif.status === 'READ' ? 'opacity-60' : '']"
              class="bg-stone-50 cursor-pointer hover:bg-stone-100 mt-3 duration-200 flex items-center justify-between rounded-lg p-2"
            >
              <span
                class="text-sm max-w-[200px] overflow-hidden block text-ellipsis whitespace-nowrap"
                >{{ notif.message }}</span
              >
              <span class="text-xs mr-auto ml-2 text-stone-600">{{
                notif.date
              }}</span>
              <span
                v-if="notif.status === 'UNREAD'"
                class="w-1 h-1 rounded-full shrink-0 bg-blue-400"
              ></span>
            </div>
          </router-link>
        </div>
        <div v-else class="py-5 text-center text-xs text-stone-500">
          اعلانی وجود ندارد
        </div>
      </div>
    </v-menu>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "NorifBox",
  props: ["newNotifList"],
  data() {
    return {
      notifList: [],
      countNotif: 0,
    };
  },
  methods: {
    setNotifListToStorage(notifList) {
      if (notifList && notifList?.length !== 0) {
        const arrayFormated = notifList.map((i) => {
          return {
            message: i.message,
            route: i.route,
            date: this.getTime(),
            status: "UNREAD",
          };
        });
        this.notifList = [...this.notifList, ...arrayFormated];
        localStorage.setItem("notifList", JSON.stringify(this.notifList));
      }
    },
    getNotifListToStorage() {
      const dataList = JSON.parse(localStorage.getItem("notifList"));
      if (dataList) {
        this.notifList = dataList;
      } else {
        localStorage.setItem("notifList", JSON.stringify([]));
        this.notifList = [];
      }
    },
    clearNotifList() {
      localStorage.removeItem("notifList");
      this.getNotifListToStorage();
      this.$emit("clear");
    },
    updateCountNotif(notifList) {
      this.countNotif = 0;
      notifList.forEach((i) => {
        i.status === "UNREAD" ? (this.countNotif += 1) : "";
      });
    },
    changeStatus(index) {
      const notif = this.notifList[index];
      notif.status = "READ";
      localStorage.setItem("notifList", JSON.stringify(this.notifList));
      this.updateCountNotif(this.notifList);
    },
    getTime() {
      let time = new Date();
      return (
        time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds()
      );
    },
  },
  mounted() {
    this.getNotifListToStorage();
    this.setNotifListToStorage(this.newNotifList);
     
  },
  watch: {
    newNotifList(v) {
      if (v && v?.length !== 0) {
        const data = v.pop();
        const signleFormated = [
          {
            message: data.message,
            route: data.route,
            date: this.getTime(),
            status: "UNREAD",
          },
        ];
        this.$refs.sound.play();
        Vue.$toast.open({
          message: data.message,
          type: "info",
          duration :15000
        });
        this.notifList = [...this.notifList, ...signleFormated];
        localStorage.setItem("notifList", JSON.stringify(this.notifList));
      }
    },
    notifList(v) {
      this.updateCountNotif(v);
    },
  },
};
</script>

<style scoped>
.v-menu__content {
  box-shadow: none;
}
</style>
